import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwFormControlLookupComponent } from '@devwareapps/devware-cap';

@DwComponent({
  key: 'pilexos-airport-multi-select',
  name: 'Airport Multi Select',
  componentType: DwComponentType.formControl,
  isGlobal: true
})
@Component({
  selector: 'app-airport-multi-select',
  template: `
    <div 
      class="dynamic-field form-input" 
      [formGroup]="formGroup">

      <dw-auto-complete-lookup [formControlName]="fieldDef?.attrName" [lookupId]="lookupId" [options]="fieldDef?.controlOptions" useServerSearch="true" [paramValues]="paramValues" [overrideValues]="fieldDef?.attr?.CustomListValues" [valueAttrName]="fieldDef?.alternateLookupValueAttrName || 'Id'" [useTransitions]="fieldDef?.lookupConfig?.useTransitions" [additionalDataField]="fieldDef?.lookupConfig?.addittionalDisplayAttrName" [placeholder]="fieldDef?.placeholderText || ''">
      </dw-auto-complete-lookup>
    </div>
  `,
})
export class AirportMultiSelectComponent extends DwFormControlLookupComponent {


  ngOnInit(): void {
  }

}
